import { render, staticRenderFns } from "./AccountSetUp.vue?vue&type=template&id=52a9115c&scoped=true&"
import script from "./AccountSetUp.vue?vue&type=script&lang=js&"
export * from "./AccountSetUp.vue?vue&type=script&lang=js&"
import style0 from "./AccountSetUp.vue?vue&type=style&index=0&id=52a9115c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a9115c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a9115c')) {
      api.createRecord('52a9115c', component.options)
    } else {
      api.reload('52a9115c', component.options)
    }
    module.hot.accept("./AccountSetUp.vue?vue&type=template&id=52a9115c&scoped=true&", function () {
      api.rerender('52a9115c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/AccountSetUp.vue"
export default component.exports